import React, { Component } from 'react';
import PropTypes from 'prop-types';

class WizardContainer extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onSave: PropTypes.func,
    onDismiss: PropTypes.func
  };

  static defaultProps = {
    onSave: () => {}
  };

  state = {
    shouldRenderWizard: true,
    step: 0
  };

  toggleWizard = () =>
    this.setState(prevState => ({
      shouldRenderWizard: !prevState.shouldRenderWizard
    }));

  moveToNextStep = () => {
    if (this.state.step < this.props.children.length - 1) {
      this.setState(prevState => ({ step: prevState.step + 1 }));
    } else {
      this.props.onSave();
    }
  };

  moveToPrevStep = () => {
    if (this.state.step > 0) {
      this.setState(prevState => ({ step: prevState.step - 1 }));
    } else {
      this.toggleWizard();
      if (this.props.onDismiss) {
        this.props.onDismiss();
      }
    }
  };

  render() {
    const childWithProp = React.Children.map(this.props.children, child => React.cloneElement(child, {
        onDismiss: this.moveToPrevStep,
        onNext: this.moveToNextStep
      }));

    return this.state.shouldRenderWizard
      ? childWithProp[this.state.step]
      : null;
  }
}

export default WizardContainer;
